function t(t){return t.replaced_at||t.updated_at||t.created_at||""}export{t as default};
//# sourceMappingURL=getDocumentDateToDisplay.js.map
